import { takeEvery, put } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { transformComplaint } from 'data/transformers/complaint';
import * as api from 'data/api';
import { actions } from './slice';
export function* getComplaint(_ref) {
  let {
    payload: {
      complaintId
    }
  } = _ref;
  const response = yield* call(api.getComplaint, complaintId.toString());

  if ('errors' in response) {
    var _response$errors, _response$errors$;

    yield put(actions.getComplaintFailure({
      error: (response === null || response === void 0 ? void 0 : (_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : (_response$errors$ = _response$errors[0]) === null || _response$errors$ === void 0 ? void 0 : _response$errors$.value) || null
    }));
    return;
  }

  yield put(actions.getComplaintSuccess(transformComplaint(response.complaint)));
}
export default function* saga() {
  yield takeEvery(actions.getComplaintRequest, getComplaint);
}